class QuotationsController implements ng.IComponentController {
    constructor() {
        'ngInject';
    }
}

export const quotationsComponent : ng.IComponentOptions = {
    controller : QuotationsController,
    template :require('./quotations.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/quotations/quotations.component.ts